// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2l85F","search":"Settings_search__24gO8","filter":"Settings_filter__2tUHX"};